import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { bomCapturaApi } from '@/services/api'
import type { BOMCompleto } from '@/types/bomCaptura'
import { evaluarBloques } from '@/utils/bomCaptura'

// Referencia estable para el caso "sin datos": evita que `?? []` cree un array
// nuevo en cada render (dispararía bucles en los useEffect que dependen de él).
const EMPTY: never[] = []

/** BOM completo de una versión (formula+empresa) + resumen de los 6 bloques. */
export function useBOM(itemId: string, empresa: string, formula: string) {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['bom', itemId, empresa, formula],
    queryFn: () => bomCapturaApi.getBOM(itemId, empresa, formula),
    enabled: Boolean(itemId && empresa && formula),
    staleTime: 60 * 1000,
  })

  const bom = data?.data as BOMCompleto | undefined
  const resumen = useMemo(() => (bom ? evaluarBloques(bom) : null), [bom])

  return {
    bom,
    cabecera: bom?.cabecera,
    lineas: bom?.lineas ?? EMPTY,
    capturas: bom?.capturas ?? EMPTY,
    resumen,
    totalLineas: bom?.totalLineas ?? 0,
    lineasCompletas: bom?.lineasCompletas ?? 0,
    isLoading,
    isError,
    refetch,
    updatedAt: data?.updatedAt,
  }
}
